export const R1 = "R1";
export const R2 = "R2";
export const R3 = "R3";
export const R4 = "R4";
export const R5 = "R5";
export const R6 = "R6";
export const R7 = "R7";
export const R8 = "R8";
export const R9 = "R9";
export const R10 = "R10";

export const D1 = "D1";
export const D2 = "D2";
export const D3 = "D3";
export const D4 = "D4";
export const D5 = "D5";
export const D6 = "D6";
export const D7 = "D7";
export const D8 = "D8";
export const D9 = "D9";
export const D10 = "D10";

export const C1 = "C1";
export const C2 = "C2";
export const C3 = "C3";
export const C4 = "C4";
export const C5 = "C5";
export const C6 = "C6";
export const C7 = "C7";
export const C8 = "C8";
export const C9 = "C9";
export const C10 = "C10";
export const C11 = "C11";
export const C12 = "C12";

export const Q1 = "Q1";
export const Q2 = "Q2";
export const Q3 = "Q3";
export const Q4 = "Q4";
export const Q5 = "Q5";
export const Q6 = "Q6";
export const Q7 = "Q7";
export const Q8 = "Q8";
export const Q9 = "Q9";
export const Q10 = "Q10";
export const Q11 = "Q11";
export const Q12 = "Q12";
export const Q13 = "Q13";
export const Q14 = "Q14";
export const Q15 = "Q15";
export const Q16 = "Q16";
export const Q17 = "Q17";
export const Q18 = "Q18";

export const A = "A";
export const B = "B";
export const C = "C";
